"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = exports.styles = {};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/styles/index.js
// module id = 471
// module chunks = 0